export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR'
export const SIGN_IN_GOOGLE = 'SIGN_IN_GOOGLE'
export const SIGN_IN_GOOGLE_SUCCESS = 'SIGN_IN_GOOGLE_SUCCESS'
export const SIGN_IN_GOOGLE_ERROR = 'SIGN_IN_GOOGLE_ERROR'
export const SIGN_IN_GOOGLE_RESET = 'SIGN_IN_GOOGLE_RESET'
export const SIGN_OUT = 'SIGN_OUT'
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'
export const SIGN_OUT_ERROR = 'SIGN_OUT_ERROR'

/**
 * Sign In
 */
export interface SignInRequestDto {
  keepSession: boolean
  password: string
  user: string
}

export interface SignIn {
  type: typeof SIGN_IN
  payload: SignInRequestDto
}

export interface SignInSuccess {
  type: typeof SIGN_IN_SUCCESS
  payload: null
}

export interface SignInError {
  type: typeof SIGN_IN_ERROR
  payload: { errorCause }
}

/**
 * Sign In Google
 */

export interface SignInGoogleRequestDto {
  token: string
}

export interface SignInGoogleRequestErrorDto {
  token: string
  errorCause: string
}

export interface SignInGoogle {
  type: typeof SIGN_IN_GOOGLE
  payload: SignInGoogleRequestDto
}

export interface SignInGoogleSuccess {
  type: typeof SIGN_IN_GOOGLE_SUCCESS
  payload: null
}

export interface SignInGoogleError {
  type: typeof SIGN_IN_GOOGLE_ERROR
  payload: SignInGoogleRequestErrorDto
}

export interface SignInGoogleReset {
  type: typeof SIGN_IN_GOOGLE_RESET
  payload: null
}

export interface SignOut {
  type: typeof SIGN_OUT
  payload: null
}

export interface SignOutSuccess {
  type: typeof SIGN_OUT_SUCCESS
  payload: null
}

export interface SignOutError {
  type: typeof SIGN_OUT_ERROR
  payload: null
}

export interface AuthState {
  data: {} | null
  accountExist: boolean | null
  signInMethod: string | null
  errorCause: string | null
  signInStates: {
    loading: boolean
    success: boolean
    error: boolean
  }
  token: string | null
  googleStates: {
    loading: boolean
    success: boolean
    error: boolean
  }
  signOutStates: {
    loading: boolean
    success: boolean
    error: boolean
  }
}

export const initialState: AuthState = {
  data: {} || null,
  accountExist: null,
  signInMethod: null,
  errorCause: null,
  signInStates: {
    loading: false,
    success: false,
    error: false,
  },
  token: null,
  googleStates: {
    loading: false,
    success: false,
    error: false,
  },
  signOutStates: {
    loading: false,
    success: false,
    error: false,
  },
}

export type AuthActions =
  | SignIn
  | SignInSuccess
  | SignInError
  | SignInGoogle
  | SignInGoogleSuccess
  | SignInGoogleError
  | SignInGoogleReset
  | SignOut
  | SignOutSuccess
  | SignOutError
